module.exports = __webpack_public_path__ + "static/media/AU 2019 Research Roster - Feedback Workshops - Oct 14.d44e4c5a.xlsx";